import { SimpleErrorReport } from '@nrk/dh-simple-error-report'

export function createErrorReporter(name, isErrorReportingEnabled, url) {
  return new SimpleErrorReport({
    name,
    url,
    dryRun: !isErrorReportingEnabled
  })
}
